export const translations = {
  sindhi: {
    // Membership Form
    membershipForm: "ميمبرشپ فارم",
    membershipClause: "ڏسو “سنڌ سنگت” جي 1998ع واري پيٽي قاعدن جو فقرو_3",
    fullNameSurname: "نالو پورو زات سميت",
    profession: "ڪرت",
    age: "عمر",
    placeOfBirth: "ڄم جو ھنڌ",
    education: "تعليمي لياقتون",
    literaryField: "ادب جي صنف",
    iAgree: "آئون سنڌي ادبي سنگت جي متن ۽ مقصدن سان شامل راء آهيان ۽ ان جو/جي ميمبر ٿيان ٿو/ٿي ۽ ان جي في ادا ڪريان ٿو/ ٿي.",
    membershipApplication: "ميمبرشپ درخواست",
    literaryFields: "ادبي صنفون",
    literaryFieldsHint: "ڪمپيوٽر تي Ctrl يا Mac تي Cmd کي دٻائي گھڻيون صنفون چونڊيو",
    manageLiteraryFields: "ادبي صنفن جو انتظام",
    literaryFieldsDescription: "ميمبر پروفائيل لاءِ دستياب ادبي شعبن کي شامل ڪريو، تبديل ڪريو ۽ منظم ڪريو.",
    addField: "صنف شامل ڪريو",
    fieldName: "صنف جو نالو",
    fieldNameSindhi: "صنف جو نالو (سنڌي)",

    // Navigation & Common
    home: 'گھر',
    about: 'بابت',
    branches: 'شاخون',
    books: 'ڪتاب',
    board: 'بورڊ',
    qanoon: 'قانون',
    ohdedaran: 'عهديدار',
    events: 'تقريبون',
    contact: 'رابطو',
    login: 'داخل ٿيو',
    register: 'رجسٽر ٿيو',
    logout: 'نڪتل ٿيو',
    adminPanel: 'ايڊمن پينل',
    memberPanel: 'ميمبر پينل',
    overview: 'جائزو',
    myWritings: 'منهنجون لکڻيون',
    noWritingsYet: 'توهان اڃا تائين ڪا به لکڻي شامل ناهي ڪئي.',


    requestsApprovals: 'درخواستون ۽ منظوريون',
    contentManagement: 'مواد جي انتظاميه',
    branchRequests: 'شاخ جي درخواستون',
    manageBranches: 'شاخن جو انتظام',
    manageMembers: 'ميمبرن جو انتظام',
    manageUsers: 'منتظمين جو انتظام',
    manageBooks: 'ڪتابن جو انتظام',
    manageBoardMembers: 'بورڊ ميمبرن جو انتظام',
    officeBearers: 'عهديدار',
    manageEvents: 'تقريبن جو انتظام',
    voting: 'وٽنگ',
    viewWebsite: 'ويب سائيٽ ڏسو',
    adminTitle: 'سنڌي ادبي سنگت — ايڊمن',
    memberTitle: 'سنڌي ادبي سنگت — ميمبر',
    districts: 'ضلعا',
    district: 'ضلعو',
    city: 'شهر',
    branchesCount: 'شاخن جو تعداد',
    clearFilter: 'فلٽر ختم ڪريو',
    manageDistrictCouncilors: 'ضلعي ڪائونسلرن جو انتظام',
    councilorCount: '{count} ڪائونسلر مليا',
    addCouncilor: '+ ڪائونسلر شامل ڪريو',
    districtCoordinator: 'ضلعي ڪوآرڊينيٽر',
    dataMigration: 'ڊيٽا لڏپلاڻ',
    branchTransferRequests: 'شاخ منتقلي جون درخواستون',
    meetingsActivities: 'گڏجاڻيون ۽ سرگرميون',
    trackMeetingsDesc: 'شاخ جي گڏجاڻين، حاضري ۽ ميمبرن جي ڪارڪردگي جو رڪارڊ رکو',
    logNewMeeting: '+ نئين گڏجاڻي رڪارڊ ڪريو',
    meetingTitleEnglish: 'گڏجاڻي جو عنوان (انگريزي)',
    meetingTitleSindhi: 'گڏجاڻي جو عنوان (سنڌي)',
    saveLog: 'رڪارڊ محفوظ ڪريو',
    addActivity: '+ سرگرمي شامل ڪريو',
    memberPerformance: 'ميمبرن جي ڪارڪردگي / سرگرميون',
    attendanceSelect: 'حاضري (ميمبر چونڊيو)',
    tenureYear: 'مدت سال',
    selectRole: 'عهدو چونڊيو',
    chooseMember: 'ميمبر چونڊيو',
    filterByDistrict: 'ضلعي سان فلٽر ڪريو',
    addOfficeBearer: '+ عهديدار شامل ڪريو',
    officeBearersDesc: 'تمام سطحن تي تنظيمي قيادت جو انتظام ڪريو',
    transferRequests: 'منتقلي جون درخواستون',
    memberDetails: 'ميمبر جا تفصيل',
    literaryProfile: 'ادبي پروفائيل',
    status: 'صورتحال',
    approve: 'منظور ڪريو',
    makePakka: 'پڪو ميمبر بڻايو',
    pakka: 'پڪو',
    kacha: 'ڪچو',
    literaryName: 'ادبي نالو',
    dob: 'ڄمڻ جي تاريخ',
    literaryServices: 'ادبي خدمتون',
    phone: 'فون',
    email: 'اي ميل',
    temporaryAddress: 'عارضي پتو',
    permanentAddress: 'مستقل پتو',
    membershipStatus: 'ميمبرشپ جي صورتحال',
    approved: 'منظور ٿيل',
    rejected: 'مسترد ٿيل',
    active: 'فعال',
    unactive: 'غير فعال',
    manageMemberTransfers: 'ميمبرن جي منتقلي جو انتظام',
    pending: 'التوا ۾',
    transferPath: 'منتقلي جو رستو',
    currentStatus: 'موجوده صورتحال',
    approvedbyold: 'پراڻي شاخ طرفان منظور ٿيل',
    approvedbynew: 'نئين شاخ طرفان منظور ٿيل',
    completed: 'مڪمل ٿيل',
    noRequestsFound: 'ڪا به درخواست نه ملي',
    approveOld: 'پراڻي شاخ منظور ڪري',
    approveNew: 'نئين شاخ منظور ڪري',
    completeTransfer: 'منتقلي مڪمل ڪريو',
    reject: 'رد ڪريو',
    language: 'ٻولي',
    english: 'English',
    sindhi: 'سنڌي',
    // Home Page
    welcomeTitle: 'سنڌي ادبي سنگت',
    welcomeDesc: 'سنڌي ٻولي، ادب ۽ ثقافت جي عظيم ورثي کي محفوظ ڪرڻ ۽ هٿي وٺرائڻ — فن ۽ قلم جي ذريعي پوري دنيا جي برادرين کي ڳنڍڻ.',
    sindhiAdabiSangatSindh: 'سنڌي ادبي سنگت سنڌ',
    activeBranches: 'فعال شاخون',
    books_count: 'ڪتاب',
    yearsLegacy: 'سالن جو ورثو',
    explorePlatform: 'پليٽ فارم کي ڳوليو',
    platformDesc: 'سنڌي ادبي سنگت بابت سڀ ڪجهه — هڪ ئي هنڌ',
    latestNews: 'تازيون خبرون',
    viewAll: 'سڀ ڏسو →',
    becomeMember: 'ميمبر بڻجو',
    joinAsMember: 'ميمبر طور شامل ٿيو',
    branchesDesc: 'پوري پاڪستان ۽ عالمي سطح تي سرگرم شاخن جي ڳولا ڪريو.',
    booksDesc: 'سنڌي ڪتابن، رسالن ۽ ميگزينن جي ڊجيٽل لائبريري.',
    boardDesc: 'عظيم بورڊ ميمبرن سان ملو جيڪي تنظيم جي رهنمائي ڪن ٿا.',
    ohdedaanDesc: 'موجوده ۽ ماضي جا عهديدار، سندن ڪردار ۽ خدمتون.',
    eventsDesc: 'ادبي تقريبن، مشاعرن، سيمينارن ۽ خبرن سان باخبر رهو.',
    qanoonDesc: 'سنڌي ادبي سنگت جا سرڪاري قاعدا، ضابطا ۽ قانون.',
    est1958: 'قائم ٿيو 1958',
    learnMore: 'وڌيڪ ڄاڻو →',
    stayUpdatedDesc: 'سنڌي ادبي سنگت جي تازين خبرن، واقعن ۽ ادبي اعلانن سان باخبر رهو.',
    becomeMemberDesc: 'سنڌي ٻولي ۽ ادب جي واڌاري ۽ تحفظ لاءِ وقف ڪيل سڀ کان وڏي ادبي تنظيم ۾ شامل ٿيو.',
    registerNow: 'هاڻي رجسٽر ٿيو',
    members: 'ميمبر',
    branchMembers: 'برانچ ميمبر',
    branches_count: 'شاخون',
    heritage: 'ورثو',
    joinUs: 'اسان سان شامل ٿيو',
    exploreMore: 'اسان جي ڪهاڻي ڳوليو',
    // Branch Detail
    aboutBranch: 'شاخ بابت',
    branchSecretary: 'شاخ سيڪريٽري',
    establishedYear: 'قيام جو سال',
    recentActivity: 'تازيون سرگرميون',
    branchActivitySubtitle: 'هن شاخ جون تازيون گڏجاڻيون، تقريبون ۽ سرگرميون',
    reportActivity: 'سرگرمي رپورٽ ڪريو',
    noActivity: 'ڪا به تازي سرگرمي نه ملي',
    approvedMembersCount: 'منظور ٿيل ميمبر',
    branchMembersSubtitle: 'هن شاخ جا سنڌي ادبي سنگت جا وقف ٿيل ميمبر',
    noApprovedMembers: 'هن شاخ لاءِ ڪو به منظور ٿيل ميمبر نه مليو',
    email_label: 'اي ميل',
    phone_label: 'فون',
    manageBranch: 'شاخ جو انتظام ڪريو',
    tbd: 'جلد اعلان ڪيو ويندو',
    noDesc: 'هن شاخ لاءِ ڪا به معلومات موجود ناهي.',
    branchNotFound: 'شاخ نه ملي',

    // Branches
    allBranches: 'سموچيون شاخون',
    branchName: 'شاخ جو نالو',
    city: 'شهر',
    country: 'ملڪ',
    secretary: 'سيڪريٽري',
    established: 'قائم ڪيو ويو',
    joinBranch: 'شاخ ۾ شامل ٿيو',
    noBranches: 'ڪوئي شاخ دستياب نهي',

    // Books
    booksLibrary: 'ڪتابن جي لائبريري',
    author: 'ليکڪ',
    year: 'سال',
    type: 'قسم',
    book: 'ڪتاب',
    journal: 'رسالو',
    magazine: 'ميگزين',
    search: 'ڳولا',
    noBooks: 'ڪوئي ڪتاب دستياب نهي',
    backToLibrary: '← واپس ڪتابن ڏانهن',
    bookDetails: 'ڪتاب جا تفصيل',
    downloadBook: 'ڪتاب ڊائون لوڊ ڪريو',
    myAddedBooks: 'منهنجا شامل ڪيل ڪتاب',
    otherBooks: 'ٻيا ڪتاب',




    // Board
    boardMembers: 'بورڊ جا ميمبر',
    designation: 'عهدو',
    tenure: 'مدت',
    current: 'موجوديہ',
    past: 'ماضي',

    // Events
    eventsNews: 'تقريبون ۽ خبرون',
    event: 'تقريب',
    news: 'خبر',
    announcement: 'اعلان',
    date: 'تاريخ',
    venue: 'مقام',
    noEvents: 'ڪوئي تقريب دستياب نهي',
    eventNotFound: 'تقريب نه ملي',
    eventNotFoundDesc: 'اها تقريب جيڪا توهان ڳولي رهيا آهيو موجود ناهي يا ختم ڪئي وئي آهي.',
    backToEvents: '← واپس تقريبن تي',
    eventDetailsTitle: 'تقريب جو تفصيل',
    descriptionLabel: 'تفصيل',
    postedOn: 'پوسٽ ڪيو ويو',

    // Forms
    name: 'نالو',
    email: 'ای میل',
    phone: 'فون',
    password: 'پاسورڊ',
    confirmPassword: 'پاسورڊ جي تصديق ڪريو',
    submit: 'جمع ڪريو',
    cancel: 'رد ڪريو',
    save: 'محفوظ ڪريو',
    delete: 'خارج ڪريو',
    edit: 'تبديل ڪريو',
    add: 'شامل ڪريو',
    update: 'اپڊيٽ ڪريو',
    administrator: 'منتظم',

    // Messages
    loading: 'لوڊ ٿي رهيو آهي...',
    success: 'ڪامياب!',
    error: 'غلطي!',
    noPermission: 'اجازت ناھي',
    unauthorized: 'غير مجاز',

    // Admin
    admin: 'ايڊمن',
    dashboard: 'ڊيش بورڊ',
    manageMembers: 'ميمبرن جو انتظام',
    manageBranches: 'شاخن جو انتظام',
    manageBooks: 'ڪتابن جو انتظام',
    manageEvents: 'تقريبن جو انتظام',
    manageBoardMembers: 'بورڊ جو انتظام',
    settings: 'سيٽنگون',
    profile: 'پروفائيل',

    // Contact
    contactUs: 'اسان سان رابطو ڪريو',
    message: 'پيغام',
    sendMessage: 'پيغام موڪليو',
    address: 'پتو',
    phone_label: 'فون نمبر',
    email_label: 'اي ميل',

    // Auth
    memberRegistration: 'ميمبر رجسٽريشن',
    alreadyMember: 'اڳ ۾ ئي کاتو آهي؟',
    noAccount: 'کاتو ناهي؟',
    forgotPassword: 'پاسورڊ وساري ويٺا؟',
    registerNow: 'هاڻي رجسٽر ٿيو',
    loginNow: 'هاڻي لاگ ان ٿيو',

    // Office Bearers
    officeBearers: 'عهديدار',
    hierarchy: 'درجه بندي',
    position: 'عھدو',
    reportingTo: 'رپورٽنگ',
    addBearer: 'عهديدار شامل ڪريو',
    emailAddress: 'اي ميل پتو',
    emailPlaceholder: 'admin@sindhiadabisangat.com',
    passwordPlaceholder: '••••••••',
    signingIn: 'داخل ٿي رهيو آهي...',
    signIn: 'داخل ٿيو',
    notAMember: 'ميمبر ناهي؟',
    backToWebsite: '← ويب سائيٽ ڏانهن واپس',
    loginFailed: 'لاگ ان ناڪام ٿيو',
    loginTitle: 'سنگت پورٽل',
    loginSubtitle: 'سنڌي ادبي سنگت ۾ داخل ٿيو',
    membersCountMsg: 'سسٽم ۾ توهان وٽ {count} {status} ميمبر آهن.',
    searchPlaceholder: 'نالي، اي ميل يا شهر سان ڳولا ڪريو...',
    memberLabel: 'ميمبر',
    contactLabel: 'رابطو',
    locationLabel: 'مقام',
    branchLabel: 'شاخ',
    statusLabel: 'حالت',
    languageLabel: 'ٻولي',
    description: 'تفصيل',
    sadar: 'صدر',
    secretary: 'سيڪريٽري',
    vice_secretary: 'نائب سيڪريٽري',
    treasurer: 'خزانچي',
    member: 'ميمبر',
    phoneLabel: 'فون',
    emailLabel: 'اي ميل',
    tenureLabel: 'مدت',
    actionsLabel: 'عمل',
    noMembersFoundMsg: 'هن زمري ۾ ڪو به ميمبر نه مليو',
    joinedLabel: 'شامل ٿيو',
    noPhone: 'ڪو به فون نمبر ناهي',
    approveBtn: 'منظور ڪريو',
    rejectBtn: 'رد ڪريو',
    resetBtn: 'ري سيٽ ڪريو',
    memberStatusUpdated: 'ميمبر جي حالت اپڊيٽ ڪئي وئي',
    pendingLabel: 'التوا ۾',
    hello: 'سلام',
    securityNote: 'سيڪيورٽي نوٽ',
    secureSessionMsg: 'توهان هڪ محفوظ سيشن مان لاگ ان ٿيل آهيو. مهرباني ڪري سيشن ختم ٿيڻ کانپوءِ لاگ آئوٽ ڪرڻ ياد رکو.',
    activeLabel: 'فعال',
    connectedLabel: 'ڳنڍيل',
    runningLabel: 'جاري آهي',
    unknownLabel: 'اڻڄاتل',
    uncategorizedLabel: 'غير زمرو ٿيل',
    searchPublications: 'اشاعتون ڳوليو...',
    noBooksFoundMsg: 'توهان جي ڳولا سان ملندڙ ڪو به ڪتاب نه مليو',
    noPublicationsMsg: 'هن زمري ۾ ڪا به اشاعت ناهي',
    addNewLabel: 'نئون شامل ڪريو',
    titleEnglish: 'عنوان (انگريزي)',
    titleSindhi: 'عنوان (سنڌي)',
    branchNameEnglish: 'شاخ جو نالو (انگريزي)',
    branchNameSindhi: 'شاخ جو نالو (سنڌي)',
    districtNameEnglish: 'ضلعي جو نالو (انگريزي)',
    districtNameSindhi: 'ضلعي جو نالو (سنڌي)',
    fullNameEnglish: 'پورو نالو (انگريزي)',
    fullNameSindhi: 'پورو نالو (سنڌي)',
    authorEnglish: 'ليکڪ (انگريزي)',
    authorSindhi: 'ليکڪ (سنڌي)',
    publisherEnglish: 'پبلشر (انگريزي)',
    publisherSindhi: 'پبلشر (سنڌي)',
    meetingTitleEnglish: 'گڏجاڻي جو عنوان (انگريزي)',
    meetingTitleSindhi: 'گڏجاڻي جو عنوان (سنڌي)',
    publishedYear: 'اشاعت جو سال',
    publicationType: 'اشاعت جو قسم',
    fileAttachment: 'فائل منسلڪ (PDF)',
    chooseFile: 'فائل چونڊيو',
    changeFile: 'فائل تبديل ڪريو',
    savePublication: 'اشاعت محفوظ ڪريو',
    publication: 'اشاعت',
    itemsCountMsg: 'توهان وٽ {count} شيون پوسٽ ٿيل آهن.',
    globalLabel: 'عالمي',
    deleteConfirm: 'خارج ڪرڻ جي پڪ آهي؟',
    updatedMsg: 'اپڊيٽ ٿي ويو!',
    postedMsg: 'پوسٽ ٿي ويو!',
    deletedMsg: 'خارج ٿي ويو',
    uploadPhoto: 'تصوير اپلوڊ ڪريو',
    changePhoto: 'تصوير تبديل ڪريو',
    titleLabel: 'عنوان',
    titleRequired: 'گهٽ ۾ گهٽ هڪ ٻولي ۾ عنوان گهربل آهي',
    fileTooLarge50: 'فائل تمام وڏي آهي (وڌ ۾ وڌ 50MB)',
    fileSelected: 'فائل اپلوڊ لاءِ چونڊي وئي',
    errorSavingBook: 'ڪتاب محفوظ ڪرڻ ۾ غلطي',
    deleteConfirmPermanent: 'ڇا توهان پڪ سان هن ڪتاب کي مستقل طور ختم ڪرڻ چاهيو ٿا؟',
    errorDeleting: 'خارج ڪرڻ ۾ غلطي',
    optional: 'اختياري',
    downloadsLabel: 'ڊائون لوڊ',
    publications: 'اشاعتون',
    stats: 'انگ اکر',
    uncategorized: 'غير زمرو ٿيل',
    unknown: 'اڻڄاتل',
    downloads: 'ڊائون لوڊ',
    assignSecretaryLabel: 'سيڪريٽري مقرر ڪريو',
    branchSecretaryUpdated: 'شاخ جو سيڪريٽري اپڊيٽ ٿي ويو!',
    branchUpdated: 'شاخ اپڊيٽ ٿي وئي!',
    branchCreated: 'شاخ ٺاهي وئي!',
    noBranchesFound: 'هن زمري ۾ ڪا به شاخ نه ملي',
    selectMember: 'ميمبر چونڊيو',
    currentSecretary: 'موجوده سيڪريٽري',
    updateBranch: 'شاخ اپڊيٽ ڪريو',
    createBranch: 'شاخ ٺاهيو',
    selectSecretary: '-- سيڪريٽري چونڊيو --',
    selectMemberPlaceholder: '-- ميمبر چونڊيو --',
    branchSecretaryNote: 'چونڊيل شخص هن شاخ لاءِ انتظامي اختيارن سان گڏ شاخ جو سيڪريٽري بڻجي ويندو.',
    assignSecretaryOptional: 'شاخ جو سيڪريٽري مقرر ڪريو (اختياري)',
    assignSecretaryMsg: '{branch} لاءِ سيڪريٽري طور مقرر ڪرڻ لاءِ ميمبر چونڊيو.',
    boardMember: 'بورڊ ميمبر',
    officeBearer: 'عهديدار',
    headOffice: 'هيڊ آفيس',
    displayOrder: 'ڏيکارڻ جي ترتيب',
    currentlyActive: 'هن وقت فعال آهي',
    presentLabel: 'موجوده',
    pastLabel: 'ماضي',
    branchJoinRequests: 'شاخ ۾ شامل ٿيڻ جون درخواستون',
    reviewApproveMembers: 'شاخ جي ميمبرن جو جائزو وٺو ۽ منظور ڪريو.',
    chooseBranch: 'شاخ چونڊيو...',
    memberLabel: 'ميمبر',
    contactLabel: 'رابطو',
    requestedLabel: 'درخواست ڪئي وئي',
    requestApproved: 'درخواست منظور ٿي وئي!',
    requestRejected: 'درخواست رد ڪئي وئي',
    failedToLoadRequests: 'درخواستون لوڊ ڪرڻ ۾ ناڪامي',
    noRequestsFound: 'ڪا به {tab} درخواست نه ملي',
    byLabel: 'پاران',
    votingSystem: 'ووٽنگ سسٽم',
    votingSessions: 'ووٽنگ سيشن',
    createVote: '+ ووٽ ٺاهيو',
    noVotingSessions: 'ڪو به ووٽنگ سيشن نه مليو',
    votesCastMsg: '{count} ووٽ پيا',
    activateBtn: 'فعال ڪريو',
    closeBtn: 'بند ڪريو',
    candidatesLabel: 'اميدوار',
    addCandidateLabel: '+ اميدوار شامل ڪريو',
    createVotingSession: 'ووٽنگ سيشن ٺاهيو',
    voteCreated: 'ووٽنگ سيشن ٺاهي وئي!',
    manageOfficeBearers: 'عهديدارن جو انتظام',
    leadershipHierarchyMsg: 'قيادت جي درجي بندي کي منظم ۽ منظم ڪريو.',
    currentHierarchy: 'موجوده عهديدار',
    pastOfficeBearersList: 'ماضي جا عهديدار',
    reportingTo: 'رپورٽنگ',
    topLevel: 'مٿين سطح',
    saveBearer: 'عهديدار محفوظ ڪريو',
    selectBranchToView: 'درجه بندي ڏسڻ لاءِ هڪ شاخ چونڊيو.',
    selectBranchToViewPast: 'ماضي جي عهديدارن کي ڏسڻ لاءِ هڪ شاخ چونڊيو.',
    noPastOfficeBearers: 'ڪو به ماضي جو عهديدار نه مليو.',
    bearerAdded: 'عهديدار شامل ڪيو ويو',
    bearerUpdated: 'عهديدار اپڊيٽ ڪيو ويو',
    archiveConfirm: 'هن عهديدار کي آرڪائيو ڪرڻ جي پڪ آهي؟',
    archivedMsg: 'آرڪائيو ٿي ويو',
    archiveLabel: 'آرڪائيو',
    reportingToLabel: 'رپورٽنگ',
    noBearersFound: 'اڃا تائين ڪو به عهديدار شامل نه ڪيو ويو آهي',
    noneLabel: 'ڪو به نه',
    main_admin: 'مين ايڊمن',
    branch_admin: 'شاخ ايڊمن',
    center_body_secretary_general: 'مرڪزي سيڪريٽري جنرل',
    center_body_joint_secretary: 'مرڪزي جوائنٽ سيڪريٽري',
    center_body_treasurer: 'مرڪزي خزانچي',
    center_body_auditor: 'مرڪزي آڊيٽر',
    center_body_woman_joint_secretary: 'مرڪزي عورت جوائنٽ سيڪريٽري',
    district_coordinator: 'ضلعي ڪوآرڊينيٽر',
    branch_secretary_general: 'شاخ سيڪريٽري جنرل',
    branch_joint_secretary: 'شاخ جوائنٽ سيڪريٽري',
    branch_treasurer: 'شاخ خزانچي',
    branch_auditor: 'شاخ آڊيٽر',
    branch_counselor: 'شاخ صلاحڪار',
    requestsApprovals: 'درخواستون ۽ منظوريون',
    languageLabel: 'ٻولي',
    description: 'تفصيل',
    sadar: 'صدر',
    secretary: 'سيڪريٽري',
    vice_secretary: 'نائب سيڪريٽري',
    treasurer: 'خزانچي',
    member: 'ميمبر',
    phoneLabel: 'فون',
    emailLabel: 'اي ميل',
    tenureLabel: 'مدت',
    joinedLabel: 'شامل ٿيو:',
    noPhone: 'فون نمبر ناهي',
    resetBtn: 'ري سيٽ',
    memberStatusUpdated: 'ميمبر جي حالت تبديل ڪئي وئي: {status}',
    imageTooLarge: 'تصوير تمام وڏي آھي (وڌ ۾ وڌ 5MB)',
    uploadImageMsg: 'مهرباني ڪري تصوير واري فائل اپلوڊ ڪريو',
    imageSelected: 'تصوير چونڊيو ويو',
    updatedMsg: 'اپڊيٽ ٿي ويو!',
    postedMsg: 'پوسٽ ٿي ويو!',
    deletedMsg: 'خارج ٿي ويو',
    imageRequired: 'تصوير گهربل آهي',
    allBranchesOption: 'سڀ شاخون',
    showGlobally: 'عالمي سطح تي ڏيکاريو',
    eventImageStar: 'تقريب جي تصوير *',
    changePhoto: 'تصوير تبديل ڪريو',
    uploadPhoto: 'تصوير اپلوڊ ڪريو',
    max5MB: 'وڌ ۾ وڌ 5MB',
    registrationGuide: 'هيٺ ڏنل فارم ڀريو. توهان جي درخواست شاخ جي سيڪريٽري طرفان جائزو ورتو ويندو.',
    registrationSuccess: 'رجسٽريشن جمع ڪئي وئي! شاخ جي سيڪريٽري جي منظوري جو انتظار ڪريو.',
    registrationFailed: 'رجسٽريشن ناڪام ٿي',
    chooseBranchPlaceholder: '-- پنهنجي شاخ چونڊيو --',
    submitRegistration: 'رجسٽريشن جمع ڪريو',
    submitting: 'جمع ٿي رهيو آهي...',
    initiatedBy: 'پاران شروع ڪيو ويو',
    noActivity: 'اڃا تائين ڪا به سرگرمي رڪارڊ نه ڪئي وئي آهي',
    branchDescriptionDefault: 'هي شاخ پنهنجي مقامي ڪميونٽي ۾ سنڌي ادب ۽ ثقافت کي هٿي ڏيڻ لاءِ باقاعده گڏجاڻين، ورڪشاپن ۽ ادبي تقريبن ذريعي وقف آهي.',
    readMore: 'وڌيڪ پڙهو',
    readOnline: 'آن لائن پڙهو',
    publicationDetails: 'هن اشاعت بابت',
    aboutBranch: 'هن شاخ بابت',
    branchId: 'شاخ جي ID',
    requestSubmitted: '✓ درخواست جمع ڪئي وئي',
    noCover: 'ڪو به ڪور موجود ناهي',
    author: 'ليکڪ',
    published: 'شايع ٿيل',
    isbn: 'ISBN',
    category: 'زمرو',

    // Branch Requests
    branchRequests: 'شاخ جون درخواستون',
    // Branch Requests & Ohdedaan & Board & Books
    officeBearersSubtitle: 'سنڌي ادبي سنگت جا عهديدار',
    noOhdedaanFound: 'ڪو به عهديدار رڪارڊ نه مليو.',
    currentBearers: 'موجوده عهديدار',
    pastBearers: 'ماضي جا عهديدار',
    boardSubtitle: 'سنڌي ادبي سنگت جي رهنمائي ڪندڙ ممتاز ميمبر',
    currentMembers: 'موجوده ميمبر',
    pastMembers: 'ماضي جا ميمبر',
    noMembersFound: 'ڪو به ميمبر نه مليو.',
    booksSubtitle: 'سنڌي ادبي ڪم جو ڊجيٽل آرڪائيو',
    searchTitleAuthor: 'عنوان يا ليکڪ ڳوليو...',
    allTypes: 'سڀ قسم',
    allLanguages: 'سڀ ٻوليون',

    // Branch Detail
    allBranchesBtn: '← سڀ شاخون',
    joinBranchAdd: '+ شاخ ۾ شامل ٿيو',
    aboutBranch: 'هن شاخ بابت',
    noDesc: 'ڪو به تفصيل موجود ناهي.',
    establishedYear: 'قائم ٿيل',
    branchSecretary: 'شاخ جو سيڪريٽري',
    tbd: 'طئي ٿيڻو آهي',
    approvedMembersCount: 'منظور ٿيل ميمبر',
    noApprovedMembers: 'اڃا تائين ڪو به ميمبر منظور نه ٿيو آهي. شامل ٿيڻ وارا پهريون بڻجو!',
    recentActivity: 'تازه ترين سرگرمي',
    branchActive: 'شاخ فعال آهي',
    branchCreationReq: 'شاخ ٺاهڻ جي درخواست جمع ڪئي وئي',

    // Admin Voting & Others
    votingSystem: 'ووٽنگ سسٽم',
    votingSessions: 'ووٽنگ سيشن',
    createVote: '+ ووٽ ٺاهيو',
    noVotingSessions: 'اڃا تائين ڪو به ووٽنگ سيشن نه ٺاهيو ويو آهي',
    reviewApproveMembers: 'شاخن ۾ شامل ٿيڻ جي درخواست ڪندڙ ميمبرن جو جائزو وٺو ۽ منظور ڪريو',
    selectBranch: 'شاخ چونڊيو',
    chooseBranch: '-- شاخ چونڊيو --',
    pendingApproval: 'منظوري جي انتظار ۾',
    addBranch: '+ شاخ شامل ڪريو',
    actions: 'عمل',
    branchJoinRequests: 'شاخ ۾ شامل ٿيڻ جون درخواستون',
    reviewApprovedMembers: 'منظور ٿيل ميمبرن جو جائزو وٺو',

    // Admin General Actions
    editLabel: 'تبديل ڪريو',
    deleteLabel: 'خارج ڪريو',
    saveLabel: 'محفوظ ڪريو',
    cancelLabel: 'رد ڪيو',
    addLabel: 'شامل ڪريو',

    // Manage Board & Ohdedaan
    addMemberBtn: '+ ميمبر شامل ڪريو',
    addOhdedarBtn: '+ عهديدار شامل ڪريو',
    fullNameStar: 'پورو نالو *',
    nameSindhiOptional: 'نالو (سنڌي)',
    designationStar: 'عھدو *',
    tenureFrom: 'مدو (کان)',
    tenureTo: 'مدو (تائين)',
    displayOrder: 'ڏيکارڻ جي ترتيب',
    currentlyActive: 'هن وقت فعال آهي',
    noBoardMembersAdded: 'اڃا تائين ڪو به بورڊ ميمبر شامل نه ڪيو ويو آهي.',
    boardMemberModal: 'بورڊ ميمبر',
    ohdedarModal: 'عهديدار',

    // Manage Events
    postNewsEventBtn: '+ خبر/تقريب داخل ڪيو',
    noEventsPosted: 'اڃا تائين ڪا به تقريب يا خبر داخل نه ڪئي وئي آهي.',
    postLabel: 'داخل ڪيو',
    typeLabel: 'قسم',
    dateLabel: 'تاريخ',
    venueLabel: 'جڳھ',
    showGlobally: 'عالمي سطح تي ڏيکاريو (سڀني شاخن لاءِ)',
    eventImageStar: 'تقريب جي تصوير *',
    max5MB: 'وڌ کان وڌ 5MB • سهڪاري فارميٽ: JPG, PNG, GIF, WebP',
    updateLabel: 'تازو ڪيو',
    titleSindhiOptional: 'عنوان (سنڌي)',
    allBranchesOption: 'سڀ شاخون',

    // Manage Office Bearers & Library
    manageOfficeBearers: 'عهديدارن جو انتظام',
    addBearerBtn: '+ عهديدار شامل ڪيو',
    currentHierarchy: 'موجوده ترتيب',
    pastOfficeBearersList: 'ماضي جا عهديدار',
    selectBranchToView: '👆 عهديدار ڏسڻ لاءِ ڪا شاخ چونڊيو',
    selectBranchToViewPast: '👆 ماضي جا عهديدار ڏسڻ لاءِ شاخ چونڊيو',
    noPastOfficeBearers: 'ماضي جو ڪوبه عهديدار ناهي',
    libraryManagement: 'لائبريري جو انتظام',
    addItemBtn: '+ ڪتاب/رسالو شامل ڪيو',
    booksObj: 'ڪتاب',
    journalsObj: 'رسالا',
    magazinesObj: 'مئگزين',
    totalDownloads: 'ڪل ڊائونلوڊ',
    categoryLabel: 'زمرو',

    pending: 'التوا ۾',
    approved: 'منظور ٿيل',
    rejected: 'رد ڪيو ويو',

    // Pagination & Lists
    showing: 'ڏيکاريل',
    of: 'جو',
    results: 'نتيجا',
    noResults: 'ڪو به نتيجو نه مليو',
    // Admin & Dashboard
    overview: 'جائزو',
    requestsApprovals: 'درخواستون ۽ منظوريون',
    contentManagement: 'مواد جو انتظام',
    voting: 'ووٽنگ',
    viewWebsite: 'ويب سائيٽ ڏسو',
    adminPanel: 'ايڊمن پينل',
    adminTitle: 'سنڌي ادبي سنگت — ايڊمن',
    totalMembers: 'ڪل ميمبر',
    booksJournals: 'ڪتاب ۽ رسالا',
    quickActions: 'فوري عمل',
    systemInfo: 'سسٽم جي ڄاڻ',
    approveMembers: 'ميمبرن کي منظور ڪريو',
    postNewsEvent: 'خبر / تقريب پوسٽ ڪريو',
    addBookJournal: 'ڪتاب / رسالو شامل ڪريو',
    addBoardMember: 'بورڊ ميمبر شامل ڪريو',
    goodMorning: 'صبح جو سلام',
    goodAfternoon: 'منجھند جو سلام',
    goodEvening: 'شام جو سلام',
    role: 'ڪردار',
    status: 'حالت',
    platform: 'پليٽ فارم',
    database: 'ڊيٽابيس',
    server: 'سرور',
    activeVotes: 'فعال ووٽ',

    // Footer & About Pages
    quickLinks: 'تڪڙا لنڪ',
    organization: 'تنظيم',
    adminLogin: 'ايڊمن لاگ ان',
    rightsReserved: 'سمورا حق محفوظ آهن',
    dedicatedTo: '1958 کان سنڌي ٻولي، ادب ۽ ثقافت جي واڌاري ۽ تحفظ لاءِ وقف.',
    aboutUs: 'اسان جي باري ۾',
    aboutTitle: 'سنڌي ادبي سنگت بابت',
    aboutDesc: 'اسان جي تاريخ، مقصد ۽ نظريو',
    ourHistory: 'اسان جي تاريخ',
    ourHistoryDesc: 'سنڌي ادبي سنگت 1958ع ۾ قائم ڪئي وئي جنهن جو مقصد سنڌي ٻولي ۽ ان جي شاندار ادبي روايتن کي هٿي ڏيڻ ۽ محفوظ ڪرڻ آهي.',
    ourMission: 'اسان جو مقصد',
    ourMissionDesc: 'سنڌي ادب لاءِ بھترين پليٽ فارم مهيا ڪرڻ، ليکڪن ۽ شاعرن جي حوصلا افزائي ڪرڻ، ۽ سڄي دنيا جي سنڌين کي ڳنڍڻ.',
    ourVision: 'اسان جو نظريو',
    ourVisionDesc: 'هڪ اهڙي دنيا جتي سنڌي ٻولي ۽ ثقافت ترقي ڪري — مستقبل جي نسلن لاءِ محفوظ رهي ۽ جديد دور جي ٽيڪنالاجي سان هم آهنگ هجي.',
    ourAchievements: 'اسان جون ڪاميابيون',
    ourAchievementsDesc: '500 کان وڌيڪ ڪتاب شايع ڪيا ويا. پوري دنيا ۾ شاخون ۽ هزارين ميمبر سنڌي ادب جي خدمت ڪري رهيا آهن.',

    // Public Pages (Events, Contact, Branches, Qanoon)
    eventsSubtitle: 'سنڌي ادبي سنگت جون تازيون خبرون، تقريبون ۽ اعلان',
    all: 'سڀ',
    eventsTab: 'تقريبون',
    newsTab: 'خبرون',
    announcementsTab: 'اعلان',
    global: 'عالمي',
    contactSubtitle: 'سنڌي ادبي سنگت سان رابطي ۾ رهو',
    headOffice: 'هيڊ آفيس',
    officeHours: 'دفتري وقت',
    officeHoursDesc: 'سومر–جمعو: 9 صبح – 5 شام\nڇنڇر: 9 صبح – 1 منجھند',
    alwaysAtYourService: 'هميشه توهان جي خدمت ۾',
    sendAMessage: 'پيغام موڪليو',
    yourName: 'توهان جو نالو *',
    subject: 'موضوع *',
    messageSent: 'پيغام موڪليو ويو! اسان جلد رابطو ڪنداسين.',
    ourBranches: 'اسان جون شاخون',
    branchesSubtitle: 'پاڪستان ۽ سڄي دنيا ۾ سنڌي ادبي سنگت جون شاخون',
    searchBranch: '🔍 نالي يا شهر سان ڳوليو...',
    active: 'فعال',
    est: 'قائم ٿيل',
    viewBranch: 'شاخ ڏسو →',
    est1958: 'قائم ٿيو 1958',
    learnMore: 'وڌيڪ ڄاڻو →',
    stayUpdatedDesc: 'سنڌي ادبي سنگت جي تازين خبرن، واقعن ۽ ادبي اعلانن سان باخبر رهو.',
    becomeMemberDesc: 'سنڌي ٻولي ۽ ادب جي واڌاري ۽ تحفظ لاءِ وقف ڪيل سڀ کان وڏي ادبي تنظيم ۾ شامل ٿيو.',
    qanoonSubtitle: 'سنڌي ادبي سنگت جا قاعدا ۽ ضابطا',
    article1Title: 'آرٽيڪل 1 — نالو ۽ سڃاڻپ',
    article1Desc: 'هن تنظيم کي "سنڌي ادبي سنگت" جي نالي سان سڃاتو ويندو. هي هڪ ادبي تنظيم آهي جيڪا سنڌي ٻولي ۽ ادب جي واڌاري لاءِ وقف ٿيل آهي.',
    article2Title: 'آرٽيڪل 2 — مقصد',
    article2Desc: 'بنيادي مقصد: (ا) سنڌي ٻولي جو فروغ؛ (ب) ڪتابن جي اشاعت؛ (ت) ادبي تقريبن جو انعقاد؛ (ث) شاخون قائم ڪرڻ؛ (ج) ورثي جو تحفظ.',
    article3Title: 'آرٽيڪل 3 — ميمبرشپ',
    article3Desc: 'شاخ جي سيڪريٽري جي ذريعي ميمبرشپ لاءِ اپلائي ڪري سگهجي ٿو.',
    article4Title: 'آرٽيڪل 4 — شاخون',
    article4Desc: 'شاخون ڪنهن به شهر ۾ گهٽ ۾ گهٽ 20 باني ميمبرن سان قائم ٿي سگهن ٿيون.',
    article5Title: 'آرٽيڪل 5 — عهديدار',
    article5Desc: 'عهديدارن جي چونڊ هر ٽن سالن ۾ هڪ دفعو جمهوري طريقي سان ڪئي ويندي.',
    article6Title: 'آرٽيڪل 6 — چونڊون',
    article6Desc: 'ووٽنگ شفاف طريقي سان اليڪشن ڪميٽي جي نگراني هيٺ ٿيندي.',
    article7Title: 'آرٽيڪل 7 — گڏجاڻيون',
    article7Desc: 'جنرل ڪائونسل گهٽ ۾ گهٽ سال ۾ ٻه ڀيرا ملندي.',
    article8Title: 'آرٽيڪل 8 — ماليات',
    article8Desc: 'تنظيم مناسب مالي ريڪارڊ برقرار رکندي.',
    qanoonSummary: 'هي صرف هڪ تت آهي. مڪمل دستاويز لاءِ هيڊ سيڪريٽري کان رجوع ڪريو.',
    recoveryKey: "ريڪوري ڪي",
    recoveryKeyNote: "مهرباني ڪري هي ريڪوري ڪي محفوظ ڪريو. اهو توهان کي پاسورڊ وسارڻ جي صورت ۾ ڪم ايندو.",
    enterRecoveryKey: "ريڪوري ڪي داخل ڪريو",
    newPassword: "نئون پاسورڊ",
    passwordResetSuccess: "پاسورڊ ڪاميابي سان تبديل ٿي ويو!",
    invalidRecoveryKey: "غلط ريڪوري ڪي يا اي ميل",
    resetPassword: "پاسورڊ ري سيٽ ڪريو",
    changePassword: "پاسورڊ تبديل ڪريو",
    passwordUpdated: "پاسورڊ اپڊيٽ ڪيو ويو!",
    updatePassword: "پاسورڊ اپڊيٽ ڪريو",
  },
  english: {
    // Membership Form
    membershipForm: "Membership Form",
    membershipClause: "See Clause 3 of the 1998 bylaws of “Sindh Sangat.”",
    fullNameSurname: "Full Name With Surname",
    profession: "Profession",
    age: "Age",
    placeOfBirth: "Place of Birth",
    education: "Education",
    literaryField: "Literary Field",
    iAgree: "I agree with the constitution and objectives of Sindhi Adabi Sangat, and I become a member of it and pay its fee.",
    membershipApplication: "Membership Application",
    literaryFields: "Literary Fields",
    literaryFieldsHint: "Hold Ctrl (on PC) or Cmd (on Mac) to select multiple fields.",
    manageLiteraryFields: "Manage Literary Fields",
    literaryFieldsDescription: "Add, edit, and manage the literary fields available for member profiles.",
    addField: "Add Field",
    fieldName: "Field Name",
    fieldNameSindhi: "Field Name (Sindhi)",

    // Navigation & Common
    home: 'Home',
    members: 'Members',
    branchMembers: 'Branch Members',
    branches_count: 'Branches',
    books: 'Books',
    board: 'Board',
    ohdedaran: 'Office Bearers',
    events: 'Events',
    contact: 'Contact',
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    adminPanel: 'Admin Panel',
    memberPanel: 'Member Panel',
    overview: 'Overview',
    myWritings: 'My Writings',
    noWritingsYet: "You haven't added any writings yet.",


    requestsApprovals: 'Requests & Approvals',
    contentManagement: 'Content Management',
    branchRequests: 'Branch Requests',
    manageBranches: 'Manage Branches',
    manageMembers: 'Manage Members',
    manageUsers: 'Manage Users',
    manageBooks: 'Manage Books',
    manageBoardMembers: 'Manage Board Members',
    officeBearers: 'Office Bearers',
    manageEvents: 'Manage Events',
    voting: 'Voting',
    viewWebsite: 'View Website',
    adminTitle: 'Sindhi Adabi Sangat — Admin',
    memberTitle: 'Sindhi Adabi Sangat — Member',
    districts: 'Districts',
    dataMigration: 'Data Migration',
    branchTransferRequests: 'Branch Transfer Requests',
    meetingsActivities: 'Meetings & Activities',
    trackMeetingsDesc: 'Track branch meetings, attendance and member performances',
    logNewMeeting: '+ Log New Meeting',
    meetingTitleEnglish: 'Meeting Title (English)',
    meetingTitleSindhi: 'Meeting Title (Sindhi)',
    saveLog: 'Save Log',
    addActivity: '+ Add Activity',
    memberPerformance: 'Member Performances / Activities',
    attendanceSelect: 'Attendance (Select Members)',
    tenureYear: 'Tenure Year',
    selectRole: 'Select Role',
    chooseMember: 'Choose Member',
    filterByDistrict: 'Filter by District',
    addOfficeBearer: '+ Add Office Bearer',
    officeBearersDesc: 'Manage organizational leadership across all levels',
    transferRequests: 'Transfer Requests',
    memberDetails: 'Member Details',
    literaryProfile: 'Literary Profile',
    status: 'Status',
    approve: 'Approve',
    makePakka: 'Make Pakka',
    pakka: 'Pakka',
    kacha: 'Kacha',
    literaryName: 'Literary Name',
    dob: 'Date of Birth',
    literaryServices: 'Literary Services',
    phone: 'Phone',
    email: 'Email',
    temporaryAddress: 'Temporary Address',
    permanentAddress: 'Permanent Address',
    membershipStatus: 'Membership Status',
    approved: 'Approved',
    rejected: 'Rejected',
    active: 'Active',
    unactive: 'Unactive',
    manageMemberTransfers: 'Manage Member Transfers',
    pending: 'Pending',
    transferPath: 'Transfer Path',
    currentStatus: 'Current Status',
    approvedbyold: 'Approved by Old Branch',
    approvedbynew: 'Approved by New Branch',
    completed: 'Completed',
    rejected: 'Rejected',
    noRequestsFound: 'No requests found',
    qanoon: 'Qanoon',
    approveOld: 'Approve (Old)',
    approveNew: 'Approve (New)',
    completeTransfer: 'Complete Transfer',
    reject: 'Reject',
    language: 'Language',
    english: 'English',
    sindhi: 'Sindhi',
    // Home Page
    welcomeTitle: 'Sindhi Adabi Sangat',
    welcomeDesc: 'Preserving the rich heritage of Sindhi language, literature, and culture — connecting communities across the world through the power of art and letters.',
    sindhiAdabiSangatSindh: 'Sindhi Adabi Sangat Sindh',
    activeBranches: 'Active Branches',
    books_count: 'Books',
    yearsLegacy: 'Years of Legacy',
    explorePlatform: 'Explore Platform',
    platformDesc: 'Everything about Sindhi Adabi Sangat — in one place',
    latestNews: 'Latest News',
    viewAll: 'View All →',
    becomeMember: 'Become a Member',
    joinAsMember: 'Join as a Member',
    branchesDesc: 'Browse all active branches across Pakistan and internationally.',
    booksDesc: 'Digital archive of Sindhi books, literary journals, and magazines.',
    boardDesc: 'Meet the distinguished board members who guide the organization.',
    ohdedaanDesc: 'Current and past office bearers with their roles and contributions.',
    eventsDesc: 'Stay updated with literary events, mushairas, seminars, and news.',
    qanoonDesc: 'Official rules, regulations, and constitution of Sindhi Adabi Sangat.',
    est1958: 'Established 1958',
    learnMore: 'Learn More →',
    stayUpdatedDesc: 'Stay updated with the latest happenings, events, and literary announcements from SAS.',
    becomeMemberDesc: 'Join thousands of Sindhi literature lovers. Register online and get approved by your nearest branch.',
    registerNow: 'Register Now',

    // Branch Detail
    aboutBranch: 'About Branch',
    branchSecretary: 'Branch Secretary',
    establishedYear: 'Established Year',
    recentActivity: 'Recent Activity',
    branchActivitySubtitle: 'Latest meetings, events and activities from this branch',
    reportActivity: 'Report Activity',
    noActivity: 'No recent activity found',
    approvedMembersCount: 'Approved Members',
    branchMembersSubtitle: 'Dedicated members of the Sindhi Adabi Sangat in this branch',
    noApprovedMembers: 'No approved members found for this branch',
    email_label: 'Email',
    phone_label: 'Phone',
    manageBranch: 'Manage Branch',
    tbd: 'To Be Announced',
    noDesc: 'No information available for this branch.',
    bookDetails: 'Book Details',
    downloadBook: 'Download Book',
    myAddedBooks: 'Added by Me',
    otherBooks: 'Other Books',



    branchNotFound: 'Branch Not Found',

    // Branches
    allBranches: 'All Branches',
    branchName: 'Branch Name',
    city: 'City',
    country: 'Country',
    secretary: 'Secretary',
    established: 'Established',
    joinBranch: 'Join Branch',
    noBranches: 'No branches available',

    // Books
    booksLibrary: 'Books & Library',
    author: 'Author',
    year: 'Year',
    type: 'Type',
    book: 'Book',
    journal: 'Journal',
    magazine: 'Magazine',
    search: 'Search',
    noBooks: 'No books available',
    backToLibrary: '← Back to Library',

    // Board
    boardMembers: 'Board Members',
    designation: 'Designation',
    tenure: 'Tenure',
    current: 'Current',
    past: 'Past',

    // Events
    eventsNews: 'Events & News',
    event: 'Event',
    news: 'News',
    announcement: 'Announcement',
    date: 'Date',
    venue: 'Venue',
    noEvents: 'No events available',
    eventNotFound: 'Event Not Found',
    eventNotFoundDesc: "The event you're looking for doesn't exist or has been removed.",
    backToEvents: '← Back to Events',
    eventDetailsTitle: 'Event Details',
    descriptionLabel: 'Description',
    postedOn: 'Posted',

    // Forms
    district: 'District',
    city: 'City',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    submit: 'Submit',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    update: 'Update',
    administrator: 'Administrator',

    // Messages
    loading: 'Loading...',
    success: 'Success!',
    error: 'Error!',
    noPermission: 'Permission Denied',
    unauthorized: 'Unauthorized',

    // Admin
    admin: 'Admin',
    dashboard: 'Dashboard',
    manageMembers: 'Manage Members',
    manageBranches: 'Manage Branches',
    manageBooks: 'Manage Books',
    manageEvents: 'Manage Events',
    manageBoardMembers: 'Manage Board',
    settings: 'Settings',
    profile: 'Profile',

    // Contact
    contactUs: 'Contact Us',
    message: 'Message',
    sendMessage: 'Send Message',
    address: 'Address',
    phone_label: 'Phone',
    email_label: 'Email',

    // Auth
    memberRegistration: 'Member Registration',
    alreadyMember: 'Already have an account?',
    noAccount: "Don't have an account?",
    forgotPassword: 'Forgot Password?',
    registerNow: 'Register Now',
    loginNow: 'Login Now',

    // Office Bearers
    officeBearers: 'Office Bearers',
    hierarchy: 'Hierarchy',
    position: 'Position',
    reportingTo: 'Reporting To',
    addBearer: 'Add Bearer',
    emailAddress: 'Email Address',
    emailPlaceholder: 'admin@sindhiadabisangat.com',
    passwordPlaceholder: '••••••••',
    signingIn: 'Signing in...',
    signIn: 'Sign In',
    notAMember: 'Not a member?',
    backToWebsite: '← Back to Website',
    loginFailed: 'Login failed',
    loginTitle: 'Sangat Portal',
    loginSubtitle: 'Sign in to Sindhi Adabi Sangat',
    membersCountMsg: 'You have {count} {status} Members in the system.',
    searchPlaceholder: 'Search by name, email or city...',
    memberLabel: 'Member',
    contactLabel: 'Contact',
    locationLabel: 'Location',
    branchLabel: 'Branch',
    statusLabel: 'Status',
    actionsLabel: 'Actions',
    noMembersFoundMsg: 'No Members found in this category',
    joinedLabel: 'Joined',
    noPhone: 'No phone',
    approveBtn: 'Approve',
    rejectBtn: 'Reject',
    resetBtn: 'Reset',
    memberStatusUpdated: 'Member status updated',
    pendingLabel: 'PENDING',
    hello: 'Hello',
    securityNote: 'Security Note',
    secureSessionMsg: 'You are logged in from a secure session. Please remember to log out after your session.',
    activeLabel: 'Active',
    connectedLabel: 'Connected',
    runningLabel: 'Running',
    unknownLabel: 'Unknown',
    uncategorizedLabel: 'Uncategorized',
    searchPublications: 'Search publications...',
    noBooksFoundMsg: 'No books found matching your search',
    noPublicationsMsg: 'No publications in this category',
    addNewLabel: 'Add New',
    titleEnglish: 'Title (English)',
    titleSindhi: 'Title (Sindhi)',
    branchNameEnglish: 'Branch Name (English)',
    branchNameSindhi: 'Branch Name (Sindhi)',
    districtNameEnglish: 'District Name (English)',
    districtNameSindhi: 'District Name (Sindhi)',
    fullNameEnglish: 'Full Name (English)',
    fullNameSindhi: 'Full Name (Sindhi)',
    authorEnglish: 'Author (English)',
    authorSindhi: 'Author (Sindhi)',
    publisherEnglish: 'Publisher (English)',
    publisherSindhi: 'Publisher (Sindhi)',
    meetingTitleEnglish: 'Meeting Title (English)',
    meetingTitleSindhi: 'Meeting Title (Sindhi)',
    publishedYear: 'Published Year',
    publicationType: 'Publication Type',
    fileAttachment: 'File Attachment (PDF)',
    chooseFile: 'Choose File',
    changeFile: 'Change File',
    savePublication: 'Save Publication',
    publication: 'Publication',
    itemsCountMsg: 'You have {count} items posted.',
    globalLabel: 'Global',
    deleteConfirm: 'Are you sure you want to delete?',
    updatedMsg: 'Updated!',
    postedMsg: 'Posted!',
    deletedMsg: 'Deleted',
    uploadPhoto: 'Upload Photo',
    changePhoto: 'Change Photo',
    titleLabel: 'Title',
    titleRequired: 'Title is required in at least one language',
    fileTooLarge50: 'File too large (max 50MB)',
    fileSelected: 'File selected for upload',
    errorSavingBook: 'Error saving book',
    deleteConfirmPermanent: 'Are you sure you want to permanently delete this book?',
    errorDeleting: 'Error deleting',
    optional: 'Optional',
    downloadsLabel: 'Downloads',
    publications: 'Publications',
    stats: 'Stats',
    uncategorized: 'Uncategorized',
    unknown: 'Unknown',
    downloads: 'Downloads',
    assignSecretaryLabel: 'Assign Secretary',
    branchSecretaryUpdated: 'Branch secretary updated!',
    branchUpdated: 'Branch updated!',
    branchCreated: 'Branch created!',
    noBranchesFound: 'No branches found in this category',
    selectMember: 'Select Member',
    currentSecretary: 'Current Secretary',
    updateBranch: 'Update Branch',
    createBranch: 'Create Branch',
    selectSecretary: '-- Select a secretary --',
    selectMemberPlaceholder: '-- Select a member --',
    branchSecretaryNote: 'The selected person will become branch secretary with admin privileges for this branch.',
    assignSecretaryOptional: 'Assign Branch Secretary (Optional)',
    assignSecretaryMsg: 'Select a member to assign as the secretary for {branch}.',
    boardMember: 'Board Member',
    officeBearer: 'Office Bearer',
    headOffice: 'Head Office',
    displayOrder: 'Display Order',
    currentlyActive: 'Currently Active',
    presentLabel: 'Present',
    pastLabel: 'Past',
    branchJoinRequests: 'Branch Join Requests',
    reviewApproveMembers: 'Review and approve branch Members.',
    chooseBranch: 'Choose a branch...',
    memberLabel: 'Member',
    contactLabel: 'Contact',
    requestedLabel: 'Requested',
    requestApproved: 'Request approved!',
    requestRejected: 'Request rejected',
    failedToLoadRequests: 'Failed to load requests',
    noRequestsFound: 'No {tab} join requests',
    byLabel: 'by',
    votingSystem: 'Voting System',
    votingSessions: 'voting sessions',
    createVote: 'Create Vote',
    noVotingSessions: 'No voting sessions created yet',
    votesCastMsg: '{count} Votes Cast',
    activateBtn: 'Activate',
    closeBtn: 'Close',
    candidatesLabel: 'Candidates',
    addCandidateLabel: '+ Add Candidate',
    createVotingSession: 'Create Voting Session',
    voteCreated: 'Vote created!',
    manageOfficeBearers: 'Manage Office Bearers',
    leadershipHierarchyMsg: 'Organize and manage the leadership hierarchy.',
    currentHierarchy: 'Current Hierarchy',
    pastOfficeBearersList: 'Past Office Bearers',
    reportingTo: 'Reporting To',
    topLevel: 'Top Level',
    saveBearer: 'Save Bearer',
    selectBranchToView: 'Select a branch to view the hierarchy.',
    selectBranchToViewPast: 'Select a branch to view past office bearers.',
    noPastOfficeBearers: 'No past office bearers found.',
    bearerAdded: 'Office bearer added',
    bearerUpdated: 'Office bearer updated',
    archiveConfirm: 'Are you sure you want to archive this office bearer?',
    archivedMsg: 'Archived',
    archiveLabel: 'Archive',
    reportingToLabel: 'Reporting To',
    noBearersFound: 'No office bearers added yet',
    noneLabel: 'None',
    main_admin: 'Main Admin',
    branch_admin: 'Branch Admin',
    center_body_secretary_general: 'Central Secretary General',
    center_body_joint_secretary: 'Central Joint Secretary',
    center_body_treasurer: 'Central Treasurer',
    center_body_auditor: 'Central Auditor',
    center_body_woman_joint_secretary: 'Central Woman Joint Secretary',
    district_coordinator: 'District Coordinator',
    branch_secretary_general: 'Branch Secretary General',
    branch_joint_secretary: 'Branch Joint Secretary',
    branch_treasurer: 'Branch Treasurer',
    branch_auditor: 'Branch Auditor',
    branch_counselor: 'Branch Counselor',
    requestsApprovals: 'Requests & Approvals',
    languageLabel: 'Language',
    description: 'Description',
    sadar: 'President (Sadar)',
    secretary: 'Secretary',
    vice_secretary: 'Vice Secretary',
    treasurer: 'Treasurer',
    member: 'Member',
    phoneLabel: 'Phone',
    emailLabel: 'Email',
    tenureLabel: 'Tenure',
    joinedLabel: 'Joined:',
    noPhone: 'No phone',
    resetBtn: 'Reset',
    memberStatusUpdated: 'Member status updated: {status}',
    imageTooLarge: 'Image too large (max 5MB)',
    uploadImageMsg: 'Please upload an image file',
    imageSelected: 'Image selected',
    updatedMsg: 'Updated!',
    postedMsg: 'Posted!',
    deletedMsg: 'Deleted',
    imageRequired: 'Image is required',
    allBranchesOption: 'All Branches',
    showGlobally: 'Show Globally',
    eventImageStar: 'Event Image *',
    changePhoto: 'Change Photo',
    uploadPhoto: 'Upload Photo',
    max5MB: 'Max 5MB',
    registrationGuide: 'Fill in the form below. Your request will be reviewed by the branch secretary.',
    registrationSuccess: 'Registration submitted! Awaiting branch secretary approval.',
    registrationFailed: 'Registration failed',
    chooseBranchPlaceholder: '-- Choose your branch --',
    submitRegistration: 'Submit Registration',
    submitting: 'Submitting...',
    initiatedBy: 'Initiated by',
    noActivity: 'No activity recorded yet',
    branchDescriptionDefault: 'This branch is dedicated to promoting Sindhi literature and culture in its local community through regular meetings, workshops, and literary events.',
    readMore: 'Read More',
    readOnline: 'Read Online',
    publicationDetails: 'About this Publication',
    aboutBranch: 'About this Branch',
    branchId: 'Branch ID',
    requestSubmitted: '✓ Request Submitted',
    noCover: 'No Cover Available',
    author: 'Author',
    published: 'Published',
    isbn: 'ISBN',
    category: 'Category',

    // Branch Requests
    branchRequests: 'Branch Requests',
    memberUpdated: 'Member updated successfully',
    memberCreated: 'Member created successfully',
    branchesCount: 'Branches Count',
    branches: 'Branches',
    clearFilter: 'Clear Filter',
    // Branch Requests & Ohdedaan & Board & Books
    officeBearersSubtitle: 'Office Bearers of Sindhi Adabi Sangat',
    noOhdedaanFound: 'No Ohdedaan records found.',
    currentBearers: 'Current Office Bearers',
    pastBearers: 'Past Office Bearers',
    boardSubtitle: 'Distinguished Members guiding Sindhi Adabi Sangat',
    currentMembers: 'Current Members',
    pastMembers: 'Past Members',
    noMembersFound: 'No Members found.',
    booksSubtitle: 'Digital archive of Sindhi literary works',
    searchTitleAuthor: 'Search title or author...',
    allTypes: 'All Types',
    allLanguages: 'All Languages',

    // Branch Detail
    allBranchesBtn: '← All Branches',
    joinBranchAdd: '+ Join Branch',
    aboutBranch: 'About this Branch',
    noDesc: 'No description available.',
    establishedYear: 'Established',
    branchSecretary: 'Branch Secretary',
    tbd: 'TBD',
    approvedMembersCount: 'Approved Members',
    noApprovedMembers: 'No approved members yet. Be the first to join!',
    recentActivity: 'Recent Activity',
    branchActive: 'Branch active',
    branchCreationReq: 'Branch creation request submitted',

    // Admin Voting & Others
    votingSystem: 'Voting System',
    votingSessions: 'voting sessions',
    createVote: '+ Create Vote',
    noVotingSessions: 'No voting sessions created yet',
    reviewApproveMembers: 'Review and approve Members requesting to join branches',
    selectBranch: 'Select Branch',
    chooseBranch: '-- Choose Branch --',
    pendingApproval: 'Pending Approval',
    addBranch: '+ Add Branch',
    actions: 'Actions',
    branchJoinRequests: 'Branch Join Requests',
    reviewApprovedMembers: 'Review approved Members',

    // Admin General Actions
    editLabel: 'Edit',
    deleteLabel: 'Delete',
    saveLabel: 'Save',
    cancelLabel: 'Cancel',
    addLabel: 'Add',

    // Manage Board & Ohdedaan
    addMemberBtn: '+ Add Member',
    addOhdedarBtn: '+ Add Ohdedar',
    fullNameStar: 'Full Name *',
    nameSindhiOptional: 'Name (Sindhi)',
    designationStar: 'Designation *',
    tenureFrom: 'Tenure From',
    tenureTo: 'Tenure To',
    displayOrder: 'Display Order',
    currentlyActive: 'Currently Active',
    noBoardMembersAdded: 'No board members added yet.',
    boardMemberModal: 'Board Member',
    ohdedarModal: 'Ohdedar',

    // Manage Events
    postNewsEventBtn: '+ Post News/Event',
    noEventsPosted: 'No events or news posted yet.',
    postLabel: 'Post',
    typeLabel: 'Type',
    dateLabel: 'Date',
    venueLabel: 'Venue',
    showGlobally: 'Show globally (all branches)',
    eventImageStar: 'Event Image *',
    max5MB: 'Max 5MB • Supported: JPG, PNG, GIF, WebP',
    updateLabel: 'Update',
    titleSindhiOptional: 'Title (Sindhi)',
    allBranchesOption: 'All Branches',

    // Manage Office Bearers & Library
    manageOfficeBearers: 'Office Bearers (Ohdedaran)',
    addBearerBtn: '+ Add Bearer',
    currentHierarchy: 'Current Hierarchy',
    pastOfficeBearersList: 'Past Office Bearers',
    selectBranchToView: '👆 Select a branch to view office bearers',
    selectBranchToViewPast: '👆 Select a branch to view past office bearers',
    noPastOfficeBearers: 'No past office bearers',
    libraryManagement: 'Library Management',
    addItemBtn: '+ Add Item',
    booksObj: 'Books',
    journalsObj: 'Journals',
    magazinesObj: 'Magazines',
    totalDownloads: 'Total Downloads',
    categoryLabel: 'Category',

    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',

    // Pagination & Lists
    showing: 'Showing',
    of: 'of',
    results: 'Results',
    noResults: 'No results found',
    // Admin & Dashboard
    overview: 'Overview',
    requestsApprovals: 'Requests & Approvals',
    contentManagement: 'Content Management',
    voting: 'Voting',
    viewWebsite: 'View Website',
    adminPanel: 'Admin Panel',
    adminTitle: 'Sindhi Adabi Sangat — Admin',
    totalMembers: 'Total Members',
    booksJournals: 'Books & Journals',
    quickActions: 'Quick Actions',
    systemInfo: 'System Info',
    approveMembers: 'Approve Members',
    postNewsEvent: 'Post News/Event',
    addBookJournal: 'Add Book/Journal',
    addBoardMember: 'Add Board Member',
    goodMorning: 'Good Morning',
    goodAfternoon: 'Good Afternoon',
    goodEvening: 'Good Evening',
    role: 'Role',
    status: 'Status',
    platform: 'Platform',
    database: 'Database',
    server: 'Server',
    activeVotes: 'Active Votes',

    // Footer & About Pages
    quickLinks: 'Quick Links',
    organization: 'Organization',
    adminLogin: 'Admin Login',
    rightsReserved: 'All Rights Reserved',
    dedicatedTo: 'Dedicated to the promotion and preservation of Sindhi language, literature, and culture since 1958.',
    aboutUs: 'About Us',
    aboutTitle: 'About Sindhi Adabi Sangat',
    aboutDesc: 'Our history, mission, and vision',
    ourHistory: 'Our History',
    ourHistoryDesc: 'Sindhi Adabi Sangat was established in 1958 with the mission to promote, preserve, and propagate the Sindhi language and its rich literary tradition.',
    ourMission: 'Our Mission',
    ourMissionDesc: 'To serve as the premier platform for Sindhi literature, nurturing writers, poets, and scholars. We organize literary events and publish books.',
    ourVision: 'Our Vision',
    ourVisionDesc: 'A world where the Sindhi language and culture flourishes — preserved for future generations while embracing the modern era.',
    ourAchievements: 'Our Achievements',
    ourAchievementsDesc: 'Over 500 books published. Thousands of members across 50+ branches. Annual literary festivals attended by thousands.',

    // Public Pages (Events, Contact, Branches, Qanoon)
    eventsSubtitle: 'Latest updates, events, and announcements from Sindhi Adabi Sangat',
    all: 'All',
    eventsTab: 'Events',
    newsTab: 'News',
    announcementsTab: 'Announcements',
    global: 'Global',
    contactSubtitle: 'Get in touch with Sindhi Adabi Sangat',
    headOffice: 'Head Office',
    officeHours: 'Office Hours',
    officeHoursDesc: 'Mon–Fri: 9am – 5pm\nSat: 9am – 1pm',
    alwaysAtYourService: 'Always at your service',
    sendAMessage: 'Send a Message',
    yourName: 'Your Name *',
    subject: 'Subject *',
    messageSent: 'Message sent! We will get back to you soon.',
    ourBranches: 'Our Branches',
    branchesSubtitle: 'Sindhi Adabi Sangat branches across Pakistan and worldwide',
    searchBranch: '🔍 Search by name or city...',
    active: 'Active',
    est: 'Established',
    viewBranch: 'View Branch →',
    est1958: 'Established 1958',
    learnMore: 'Learn More →',
    stayUpdatedDesc: 'Stay updated with the latest happenings, events, and literary announcements from SAS.',
    becomeMemberDesc: 'Join the largest literary organization dedicated to the promotion and preservation of Sindhi language and literature.',
    qanoonSubtitle: 'The Rules and Regulations of Sindhi Adabi Sangat',
    article1Title: 'Article 1 — Name & Identity',
    article1Desc: 'This organization shall be known as "Sindhi Adabi Sangat". It is dedicated to the promotion of Sindhi language and literature.',
    article2Title: 'Article 2 — Objectives',
    article2Desc: 'The primary objectives are: (a) Promotion of Sindhi language; (b) Publication of books; (c) Literary events; (d) Branches; (e) Preservation.',
    article3Title: 'Article 3 — Membership',
    article3Desc: 'Any person may apply for membership through the nearest branch.',
    article4Title: 'Article 4 — Branches',
    article4Desc: 'Branches may be established with a minimum of 20 founding members.',
    article5Title: 'Article 5 — Office Bearers',
    article5Desc: 'Elected by members through a democratic voting process every three years.',
    article6Title: 'Article 6 — Elections & Voting',
    article6Desc: 'Voting shall be conducted in a free, fair, and transparent manner.',
    article7Title: 'Article 7 — Meetings',
    article7Desc: 'The General Council shall meet at least twice a year.',
    article8Title: 'Article 8 — Finance',
    article8Desc: 'The organization shall maintain proper financial records.',
    qanoonSummary: 'This is a summary of the constitution. For the complete document, contact the Head Secretary.',

    // New translations for ManageUsers.js
    user: 'User',
    userCount: '{count} users found',
    addUser: '+ Add User',
    displayName: 'Display Name',
    noBranch: 'No Branch',
    noDistrict: 'No District',
    disabled: 'Disabled',
    enable: 'Enable',
    disable: 'Disable',
    userUpdated: 'User updated successfully',
    userCreated: 'User created successfully',

    // New translations for ManageMembers.js
    activeMembers: 'Active Members',
    pendingRequests: 'Pending Requests',
    selectDistrict: 'Select District',
    memberUpdated: 'Member updated successfully',
    memberCreated: 'Member created successfully',
    manageDistrictCouncilors: 'Manage Councilors',
    councilorCount: '{count} councilors found',
    addCouncilor: '+ Add Councilor',
    districtCoordinator: 'District Coordinator',
    recoveryKey: "Recovery Key",
    recoveryKeyNote: "Please save this recovery key. It will help you in case you forget your password.",
    enterRecoveryKey: "Enter Recovery Key",
    newPassword: "New Password",
    passwordResetSuccess: "Password reset successfully!",
    invalidRecoveryKey: "Invalid recovery key or email",
    resetPassword: "Reset Password",
    changePassword: "Change Password",
    passwordUpdated: "Password updated successfully!",
    updatePassword: "Update Password",
  }
};

export const t = (key, lang = 'sindhi') => {
  return translations[lang]?.[key] || translations.english[key] || key;
};
